module.exports = __webpack_public_path__ + "img/image128.9c9c62eb.jpg";